import { useState, useEffect } from 'react'
import _ from 'common-tools/LodashHelper'

export function useParseChildMap (children, emptyChildMap, defaultMapKey = 'Content') {
  const [childMap, setChildMap] = useState(emptyChildMap)

  useEffect(() => {
    if (_.isArray(children)) {
      const newMap = _.groupBy(children, (c) => {
        return c?.type?.DCType || 'Mystery'
      })
      setChildMap({
        ...emptyChildMap,
        ...newMap
      })
    } else {
      setChildMap({
        ...emptyChildMap,
        [defaultMapKey]: children
      })
    }
  }, [children])

  return [childMap]
}

export default useParseChildMap
